import { Component, Input, OnInit, OnChanges, SimpleChanges } from '@angular/core';
import { Experience, ExperienceShort } from '../../../services/interfaces/experiences';
import { CurrencyPipe } from '@angular/common';
import { DWSTag } from '../../../services/interfaces/tags';
import { getImageUrl } from '../../../utils/image.utils';
import { FavoritesService } from '../../../services/favorites.service';

@Component({
  selector: 'app-experience-card',
  templateUrl: './experience-card.component.html',
  styleUrl: './experience-card.component.scss'
})
export class ExperienceCardComponent implements OnInit, OnChanges {

  @Input() experience?: ExperienceShort;
  typeof: any;
  isFavorite: boolean = false;

  //initialize  in constructor
  constructor(
    private cp: CurrencyPipe,
    private favoritesService: FavoritesService
  ) {

  }

  ngOnInit(): void {
    this.checkFavoriteStatus();
  }

  ngOnChanges(changes: SimpleChanges): void {
    if (changes['experience'] && this.experience) {
      this.checkFavoriteStatus();
    }
  }

  checkFavoriteStatus(): void {
    if (!this.experience?.id) {
      this.isFavorite = false;
      return;
    }

    this.favoritesService.isFavorite(this.experience.id).subscribe({
      next: (isFav) => {
        this.isFavorite = isFav;
      },
      error: (error) => {
        console.error('Error checking favorite status:', error);
        this.isFavorite = false;
      }
    });
  }

  addToFavorites(event: Event): void {
    event.stopPropagation(); // Prevent card click event
    
    if (!this.experience?.id) {
      return;
    }

    this.favoritesService.toggleFavorite(this.experience.id).subscribe({
      next: (isFav) => {
        this.isFavorite = isFav;
      },
      error: (error) => {
        console.error('Error toggling favorite:', error);
      }
    });
  }

  formatCurrencyCents(number: number | undefined): string {
    if (!!!number) number = 0;
    var numEur = number / 100;
    return this.cp.transform(numEur, 'EUR', 'symbol', '1.0-0') || "";
  }

  maxLenghtText(text: string | undefined | null, maxLength: number): string {
    if (!text) return '';
    if (text.length <= maxLength) {
      return text;
    } else {
      return text.substring(0, maxLength - 3) + '...';
    }
  }
  
  showTag(tag: DWSTag): boolean {
    if(tag == undefined) return false;
    if(!tag.category_code) return false;
    return tag.category_code == 'mood' || tag.category_code == 'exptype';
  }

  getImageUrl(mediaUrl: string | undefined | null): string {
    return getImageUrl(mediaUrl);
  }

  /**
   * Trova l'immagine da usare per la card
   * Priorità: 1) mediaType === "mainCover", 2) prima immagine disponibile, 3) cover legacy
   */
  getCardImageUrl(): string {
    if (!this.experience) {
      return getImageUrl(null);
    }

    // Cerca prima l'immagine con mediaType === "mainCover"
    if (this.experience.medias && Array.isArray(this.experience.medias)) {
      const mainCover = this.experience.medias.find(media => media.mediaType === 'mainCover');
      if (mainCover?.mediaUrl) {
        return getImageUrl(mainCover.mediaUrl);
      }

      // Se non c'è mainCover, usa la prima immagine disponibile
      if (this.experience.medias[0]?.mediaUrl) {
        return getImageUrl(this.experience.medias[0].mediaUrl);
      }
    }

    // Fallback a cover legacy se presente
    if (this.experience.cover) {
      return getImageUrl(this.experience.cover);
    }

    // Ultimo fallback
    return getImageUrl(null);
  }
}
